import React, { Component } from "react";
import { Card, CardText, CardBody, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader, Label, FormGroup, Alert, Input, Table} from "reactstrap";
import { metadataService } from "../../_services";
import PropTypes from "prop-types";
import {
    SlRadioButton,
    TextInput,
    SlButton,
    SlBusyIndicator,
    SelectInput,
    ReadOnlyField,
    SlMoneyInput,
    SLImageSelectable
} from "../editors";
import validator from "validator";

import SlErrorMessage from "../editors/SLErrorMessage";
import { history } from "../../_helpers";
import { PaymentBreakdown } from "./PaymentBreakdown";

export class SetPayment extends Component {
    constructor(props) {
        super(props);
        this.handleChangePaymentAmount = this.handleChangePaymentAmount.bind(this);
        this.handleAmountSelectionChanged = this.handleAmountSelectionChanged.bind(this);
        this.handleChangeOtherAmount = this.handleChangeOtherAmount.bind(this);
        this.handleChangeCard = this.handleChangeCard.bind(this);
        this.handlePaymentTypeChanged = this.handlePaymentTypeChanged.bind(this);
        this.handleClickDeleteSavedPayment = this.handleClickDeleteSavedPayment.bind(this);
        this.handleToggleDeleteCardIsOpen = this.handleToggleDeleteCardIsOpen.bind(this);
        this.handleCardsDeleted = this.handleCardsDeleted.bind(this);
        this.state = {
            deleteCardIsOpen: false,
            selectedPaymentType: this.props.enableAchPayments ? "ach" : "card",
            savedPaymentMethod: "",
            cardsToDelete: [],
            amountSelection: 'suggestedPayment',
            showUpToDateBreakdown: true,
            showPayoffBreakdown: false
        }; 
    }
    componentDidMount() {
        if (this.props.loanToPay.suggestedPayment > 0) {
            this.handleAmountSelectionChanged('suggestedPayment');
        } else {
            this.handleAmountSelectionChanged('scheduledPayment');
        }

        this.props.onPaymentTypeChanged(this.state.selectedPaymentType);
    }
    handleCardsDeleted(){
        this.props.onCardsDeleted([this.state.savedPaymentMethod]);
        this.setState({ deleteCardIsOpen: false, savedPaymentMethod: ""})
    }

    handleChangePaymentAmount(e) {
        const newPaymentAmount = Number(e.target.value);
        this.props.onPaymentAmountChanged(newPaymentAmount);
    }

    handleClickDeleteSavedPayment(e){
        this.setState({deleteCardIsOpen : true});
    }

    handleToggleDeleteCardIsOpen(e){
        this.setState(prevState => ({deleteCardIsOpen : !prevState.deleteCardIsOpen}));
    }

    handlePaymentTypeChanged(e) {
        const newPaymentType = e.target.value;
        this.setState({ selectedPaymentType: newPaymentType, savedPaymentMethod: null });
        this.props.onPaymentTypeChanged(newPaymentType);
        this.handleChangeCard({ target: { value: "" } });
    }

    handleChangeCard(e) {
        const newCardId = e.target.value;
        let newCard = null;
        if (newCardId) {
            newCard = this.props.savedCards.find(
            e => e.storedPmtId.toString() === newCardId
            );
        }

        this.setState({ savedPaymentMethod: newCard == null ? "" : newCardId });
        this.props.onCardSelected(newCard);
    }

    handleAmountSelectionChanged(selection) {
        let amount = 0;
        let showUpToDateBreakdown = false;
        let showPayoffBreakdown = false;

        switch (selection) {
            case 'suggestedPayment':
                amount = this.props.loanToPay.suggestedPayment;
                showUpToDateBreakdown = true;
                showPayoffBreakdown = false;
                break;
            case 'scheduledPayment':
                amount = this.props.loanToPay.nextPaymentAmount;
                showUpToDateBreakdown = false;
                showPayoffBreakdown = false;
                break;
            case 'payoff':
                amount = this.props.loanToPay.payoff;
                showUpToDateBreakdown = false;
                showPayoffBreakdown = true;
                break;
            case 'other': 
                if (this.state.amountSelection == 'other') {
                    amount = this.state.paymentAmount;
                } else {
                    amount = '';
                }
                document.getElementsByName("PaymentAmount")[0].focus();
                showUpToDateBreakdown = false;
                showPayoffBreakdown = false;
                break;
            default:
                break;
        }

        this.setState({
            amountSelection: selection, paymentAmount: amount,
            showUpToDateBreakdown: showUpToDateBreakdown, showPayoffBreakdown: showPayoffBreakdown
        });
        this.props.onPaymentAmountChanged(Number(amount));
    }

    handleChangeOtherAmount(e) {
        let amount = e.target.value;

        this.setState({
            amountSelection: 'other',
            paymentAmount: amount
        });

        this.props.onPaymentAmountChanged(Number(amount));
    }

    getSavedPaymentLabel(payment) {
        if (payment.storedPaymentType === "card_token") {
            return payment.cardDescription + " (" + payment.cardLastFour + ") " + payment.cardExpiration.substring(0, 2) + "/" + payment.cardExpiration.substring(2);
        } else {
            return payment.accountType + " - " + payment.nameOnCheck + " (" + payment.accountLastFour + ")";
        }
    }

    render() {
        const closeBtn = <button className="close" onClick={this.handleToggleDeleteCardIsOpen}>&times;</button>;

        const savedCards = this.props.savedCards.filter(d => d.storedPaymentType === "card_token");
        const savedBanks = this.props.savedCards.filter(d => d.storedPaymentType === "ach_token");

        return (
            <Card>
                <CardBody>

                    {this.props.loanToPay.suggestedPayment > 0 ?
                        <div>
                        <Row className={'selectable-row' + (this.state.amountSelection === 'suggestedPayment' ? ' selected' : '')} onClick={() => { this.handleAmountSelectionChanged('suggestedPayment') }}>
                            <Col xs={6} sm={5}>
                                <Label className='mb-0 d-flex'>
                                    <Input type="radio" name='amountSelection' value='suggestedPayment' className='position-relative d-block mx-2 my-0'
                                        checked={this.state.amountSelection === 'suggestedPayment'} onChange={() => { this.handleAmountSelectionChanged('suggestedPayment') }} />
                                        <p className='paymentLabel'>{metadataService.getFieldNameLabel('Payment')}</p><p className="paymentSubLabel p-0">&nbsp; {metadataService.getMessage('includesSchedule')}</p>
                                </Label>
                            </Col>
                            <Col className='text-center twisty' aria-expanded={this.state.showUpToDateBreakdown}>
                                <span className='h3'>{metadataService.formatMoney(this.props.loanToPay.suggestedPayment)}</span>
                            </Col>
                            <p className="paymentSubLabelMobile p-0">&nbsp; {metadataService.getMessage('includesSchedule')}</p>
                        </Row>
                            {this.state.showUpToDateBreakdown && (
                                <Table bordered={true}>
                                    <PaymentBreakdown loan={this.props.loanToPay} breakdownType='payment' />
                                </Table>
                            )}
                        </div>
                        :
                        <Row className={'selectable-row' + (this.state.amountSelection === 'scheduledPayment' ? ' selected' : '')} onClick={() => { this.handleAmountSelectionChanged('scheduledPayment') }}>
                            <Col xs={6} sm={5}>
                                <Label className='mb-0 d-flex'>
                                    <Input type="radio" name='amountSelection' value='scheduledPayment' className='position-relative d-block mx-2 my-0'
                                        checked={this.state.amountSelection === 'scheduledPayment'} onChange={() => { this.handleAmountSelectionChanged('scheduledPayment') }} />
                                    <p className='p-0 m-0'>{metadataService.getFieldNameLabel('ScheduledMonthlyPayment')}</p>
                                </Label>
                            </Col>
                            <Col className='text-center'>
                                <span className='h3'>{metadataService.formatMoney(this.props.loanToPay.nextPaymentAmount)}</span>
                            </Col>
                        </Row>
                    }

                    <Row className={'border-top border-bottom selectable-row' + (this.state.amountSelection === 'payoff' ? ' selected' : '')} onClick={() => { this.handleAmountSelectionChanged('payoff') }}>
                        <Col xs={6} sm={5}>
                            <Label className='mb-0 d-flex'>
                                <Input type="radio" name='amountSelection' value='payoff' className='position-relative d-block mx-2 my-0'
                                    checked={this.state.amountSelection === 'payoff'} onChange={() => { this.handleAmountSelectionChanged('payoff') }} />
                                <p className='p-0 m-0'>{metadataService.getFieldNameLabel('PayoffAmount')}</p>
                            </Label>
                        </Col>
                        <Col className='text-center twisty' aria-expanded={this.state.showPayoffBreakdown}>
                            <span className='h3'>{metadataService.formatMoney(this.props.loanToPay.payoff)}</span>
                        </Col>
                    </Row>
                    {this.state.showPayoffBreakdown && (
                        <Table bordered={true}>
                            <PaymentBreakdown loan={this.props.loanToPay} breakdownType='payoff' />
                        </Table>
                    )}
                    <Row className={'selectable-row' + (this.state.amountSelection === 'other' ? ' selected' : '')} onClick={() => { this.handleAmountSelectionChanged('other') }}>
                        <Col xs={6} sm={5}>
                            <Label className='mb-0 d-flex'>
                                <Input type="radio" name='amountSelection' value='other' className='position-relative d-block mx-2 my-0'
                                    checked={this.state.amountSelection === 'other'} onChange={() => { this.handleAmountSelectionChanged('other') }} />
                                <p className='p-0 m-0'>{metadataService.getFieldNameLabel('OtherAmount')}</p>
                            </Label>
                        </Col>
                        <Col className='pt-3'>
                            <SlMoneyInput
                                name="PaymentAmount"
                                type="number"
                                step={.05}
                                maxValue={this.props.loanToPay.payoff}
                                value={this.state.amountSelection == 'other' ? this.state.paymentAmount : ''}
                                onChange={this.handleChangeOtherAmount}
                                enforceMaxLength={false}
                                showLabel={false}
                                isRequired={this.state.amountSelection == 'other'}
                            />
                        </Col>
                    </Row>
                    
                        <Row className="mt-4 justify-content-center">
                            <Col md="auto" >
                                {this.props.showPayoffError && (
                                    <Alert color="danger" style={{ margin: "0px", lineHeight: "1.2em" }}>
                                        {this.props.isBranchAvailable && (
                                            metadataService.getMessage(this.props.payoffMessage, metadataService.formatDateString(this.props.loanToPay.payoffAsOfDate), this.props.loanToPay.payoff, this.props.branchPhone, metadataService.getLabel("SupportPhone"))
                                        )}
                                
                                        {!this.props.isBranchAvailable && (
                                            metadataService.getMessage(this.props.payoffMessage, metadataService.formatDateString(this.props.loanToPay.payoffAsOfDate), this.props.loanToPay.payoff,  metadataService.getLabel("SupportPhone"))
                                        )}
                                        </Alert>                            
                            )}
                            {this.props.showSuggestedPaymentWarning && (
                                <Alert color="warning" style={{ margin: "0px", lineHeight: "1.2em" }}>
                                    {
                                        metadataService.getMessage('OtherAmount', metadataService.formatMoney(this.state.paymentAmount), metadataService.formatMoney(this.props.loanToPay.suggestedPayment))
                                    }
                                </Alert>
                            ) }
                            </Col>
                    </Row>

                    {this.props.enableAchPayments &&
                        <Row className="mb-4 justify-content-center">
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <SLImageSelectable
                                    selected={this.state.selectedPaymentType === "ach"}
                                    title={<i class="fa fa-3x fa-bank"></i>}
                                    name="paymentOption"
                                    value="ach"
                                    onChange={this.handlePaymentTypeChanged}
                                />
                            </Col>
                            <Col>
                                <h4>{metadataService.getMessage("PayByBankHeader")}</h4>
                                <p>{metadataService.getMessage("PayByBank")}</p>
                                <SelectInput
                                    name="SelectBank"
                                    showLabel={false}
                                    onChange={this.handleChangeCard}
                                    disabled={this.state.selectedPaymentType !== "ach"}
                                    isRequired={false}
                                    placeholder={metadataService.getLabel("NewBank")}
                                    options={
                                        savedBanks.map(e => {
                                        return {
                                            text:
                                                this.getSavedPaymentLabel(e),
                                            value: e.storedPmtId
                                        };
                                        })}
                                    value={this.state.savedPaymentMethod}
                                />

                                {this.state.selectedPaymentType === "ach" && this.state.savedPaymentMethod !== "" && 
                                    <a onClick={this.handleClickDeleteSavedPayment}>
                                        {metadataService.getButton("RemoveSavedBank")}
                                    </a>
                                }
                            </Col>
                        </Row>
                    }

                        <Row className="justify-content-center">
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <SLImageSelectable
                                    selected={this.state.selectedPaymentType === "card"}
                                    title={<i class="fa fa-3x fa-credit-card-alt"></i>}
                                    name="paymentOption"
                                    value="card"
                                    onChange={this.handlePaymentTypeChanged}
                                />
                            </Col>
                            <Col>
                            <h4>{metadataService.getMessage("PayByCardHeader")}</h4>
                                {this.props.convenienceFees ?
                                    <p>{metadataService.getMessage("PayByCard", this.props.convenienceFees)}</p>
                                :
                                    <p>{metadataService.getMessage("PayByCardNoFee")}</p>
                                }
                                <SelectInput
                                    name="SelectCard"
                                    showLabel={false}
                                    onChange={this.handleChangeCard}
                                    disabled={this.state.selectedPaymentType !== "card"}
                                    isRequired={false}
                                    placeholder={metadataService.getLabel("NewDebitCard")}
                                    options={
                                        savedCards.map(e => {
                                            return {
                                                text:
                                                    this.getSavedPaymentLabel(e),
                                                value: e.storedPmtId
                                            };
                                        })}
                                    value={this.state.savedPaymentMethod}
                                />

                                {this.state.selectedPaymentType === "card" && this.state.savedPaymentMethod !== "" &&
                                    <a onClick={this.handleClickDeleteSavedPayment}>
                                        {metadataService.getButton("RemoveSavedCard")}
                                    </a>
                                }
                            </Col>
                    </Row>

                        <Modal isOpen={this.state.deleteCardIsOpen} toggle={this.handleToggleDeleteCardIsOpen}>
                            <ModalHeader close={closeBtn}>
                                {metadataService.getButton("RemoveSavedPaymentMethod")}
                            </ModalHeader>
                            <ModalBody>
                                {metadataService.getMessage("ConfirmRemoveSavedPaymentMethod", this.getSavedPaymentLabel(this.state.savedPaymentMethod))}
                            </ModalBody>
                            <ModalFooter>
                                <SlButton onClick={this.handleCardsDeleted} name="Remove" disabled={this.state.savedPaymentMethod === ""} />
                                <SlButton onClick={this.handleToggleDeleteCardIsOpen} name="Cancel" />
                            </ModalFooter>
                        </Modal>
                    </CardBody>
                 </Card>
        );
    }
}

SetPayment.propTypes = {
  selectedPaymentType: PropTypes.string.isRequired,
  paymentAmount: PropTypes.number.isRequired,
  showPayoffError: PropTypes.bool.isRequired,
  showSuggestedPaymentWarning: PropTypes.bool.isRequired,
  savedCards: PropTypes.array,
  selectedCard: PropTypes.object,
  loanToPay: PropTypes.object.isRequired,
  onPaymentAmountChanged: PropTypes.func.isRequired,
  onPaymentTypeChanged: PropTypes.func.isRequired,
  onCardSelected: PropTypes.func.isRequired, 
  onCardsDeleted: PropTypes.func.isRequired,
  isBranchAvailable: PropTypes.bool.isRequired,
  payoffMessage: PropTypes.string.isRequired,
  localBranch: PropTypes.object,
  branchPhone: PropTypes.string
};
SetPayment.defaultProps = {
  savedCards: []
};
